import { Component } from '@angular/core';
import { ToastController, NavController } from 'ionic-angular';

import { globalDefines } from '../../app/app.constants';
import { GlobalVars } from '../../app/app.environment';
import { CheckProvider } from '../../providers/check/check';
import { UserProvider } from '../../providers/user/user';

@Component({
  selector: 'page-home-admin',
  templateUrl: 'home-admin.html',
})
export class HomeAdminPage {

  checks = [];
  selectedUser;
  users;

  private checksSubscription;
  private limitScroll;

  constructor(
    public navCtrl: NavController,
    public toastCtrl: ToastController,
    public globalVars: GlobalVars,
    public checkProvider: CheckProvider,
    public userProvider: UserProvider,
  ) {
    this.users = userProvider.getUserNames();
    this.limitScroll = globalDefines.limitScrollOriginal;
  }

  ionViewDidEnter() {
    this.loadChecks(this.limitScroll);
  }

  ionViewWillUnload() {
    if(this.checksSubscription && !this.checksSubscription.closed) this.checksSubscription.unsubscribe();
  }

  doInfinite(infiniteScroll) {
    setTimeout(() => {
      this.limitScroll += globalDefines.limitScrollOriginal;
        
      if(this.selectedUser) this.loadUser(this.limitScroll);
      else this.loadChecks(this.limitScroll);

      infiniteScroll.complete();
    }, 500);
  }

  loadChecks(limitScroll) {
    if(this.checksSubscription && !this.checksSubscription.closed) this.checksSubscription.unsubscribe();

    this.checksSubscription = this.checkProvider.getLastChecks(limitScroll).subscribe(checks => {
      this.checks = checks;
    });
  }

  loadUser(limitScroll) {    
    if(this.checksSubscription && !this.checksSubscription.closed) this.checksSubscription.unsubscribe();
    
    if(this.selectedUser) {
      this.checksSubscription = this.checkProvider.getLastUserChecks(limitScroll, this.selectedUser).subscribe(checks => {
        this.checks = checks;
      });
    }
  }

  removeSearch() {
    this.selectedUser = null;
    this.limitScroll = globalDefines.limitScrollOriginal;
    this.loadChecks(this.limitScroll);
  }

  ubication(check) {
    if(check.coords) {
      this.navCtrl.push('MapPage', { mode: 'check', check: check });
    }

    else this.showMessage(`Este fichaje se ha añadido manualmente o mediante de un fichador.`);
  }

  private showMessage(message: string) {
    this.toastCtrl.create({message: message, duration: globalDefines.defaultToastDuration}).present();
  }
}




// WEBPACK FOOTER //
// ./src/pages/home-admin/home-admin.ts